import Draggable from "@/lib/Draggable";
import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

interface ExtendedICellRendererParams extends Partial<ICellRendererParams> {
  cryptoID: string | undefined;
}

// NOTE: POPOUT tile needs to have rendering without the Draggable wrappers.
const MainESIDCellRenderer = ({
  data,
  cryptoID,
}: ExtendedICellRendererParams) => {
  const renderValue = data?.esid;

  const hasCryptoID = data != undefined && cryptoID != undefined;

  return (
    <div data-testid="ESIDrenderer">
      {hasCryptoID ? (
        <Draggable id={data.esid + cryptoID} value={data.esid} header={"ESID"}>
          <div
            className="overflow-hidden text-ellipsis"
            data-testid="draggableESID"
          >
            {renderValue}
          </div>
        </Draggable>
      ) : (
        <div data-testid="popoutESID">{renderValue}</div>
      )}
    </div>
  );
};

export default MainESIDCellRenderer;
